import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { subscribeTopInset } from "@/utils/telegram";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { Benefits } from "@/components/Benefits";
import { Pricing } from "@/components/Pricing";
import { PreorderForm } from "@/components/PreorderForm";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
  const [topInset, setTopInset] = useState(0);
  useEffect(() => subscribeTopInset(setTopInset), []);
  const location = useLocation();

  // Возврат к последнему месту — вопросом на входе (ResumePrompt в App.js), здесь не прыгаем.

  // При переходе по якорю (/#preorder из приложения) докручиваем до секции после монтирования
  useEffect(() => {
    if (location.hash !== "#preorder") return;
    let tries = 0;
    let timer;
    const go = () => {
      const el = document.getElementById("preorder");
      if (!el) {
        if (++tries < 20) timer = setTimeout(go, 100);
        return;
      }
      if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -60, duration: 1.2 });
      } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    timer = setTimeout(go, 350);
    // Второй проход — на случай догрузки изображений, сдвигающих цель
    const timer2 = setTimeout(go, 1200);
    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
    };
  }, [location.hash]);

  return (
    <div
      className="min-h-screen bg-[#0A0A0A]"
      style={{ paddingTop: topInset }}
      data-testid="landing-page"
    >
      <Header />
      <main>
        {/* Единая еле видимая фактура лица за всеми секциями */}
        <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-0">
          <img
            src="/images/hero-face-dim.jpg"
            alt=""
            className="h-full w-full object-cover object-[50%_18%] opacity-[0.045]"
            style={{
              WebkitMaskImage: "linear-gradient(to bottom, transparent, black 12%, black 88%, transparent)",
              maskImage: "linear-gradient(to bottom, transparent, black 12%, black 88%, transparent)",
            }}
          />
          <div className="absolute -bottom-24 -right-24 h-[420px] w-[420px] rounded-full bg-[#C2A878]/[0.05] blur-[130px]" />
        </div>

        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Benefits />
        <Pricing />

        <section
          id="preorder"
          className="relative px-6 pb-28 pt-16 md:px-12 md:py-40 lg:px-24"
          data-testid="preorder-section"
        >
          <div
            aria-hidden="true"
            className="pointer-events-none absolute right-0 top-0 h-[500px] w-[500px] rounded-full bg-[#C2A878]/[0.04] blur-[120px]"
          />
          <div className="grid items-center gap-16 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <motion.p
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                className="mb-8 font-jetbrains text-xs uppercase tracking-[0.35em] text-[#C2A878]"
              >
                ( Доступ )
              </motion.p>
              <motion.h2
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
                className="font-cormorant text-4xl font-light leading-[1.05] tracking-tight text-[#F4F4F0] md:text-6xl"
              >
                Узнайте свою стрижку до визита к мастеру
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
                className="mt-8 max-w-md text-base leading-relaxed text-[#A3A3A3] md:text-lg"
              >
                Оставьте имя и подтвердите номер одним тапом — откроем доступ навсегда
                и подарим бесплатную ИИ-примерку новой стрижки на вашем фото.
              </motion.p>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 48 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="lg:col-span-6 lg:col-start-7"
            >
              <PreorderForm />
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
